<template>
    <div :data-cy="$attrs['data-cy'] || 'input_label_national_id'">
        <div class="text-sm" :class="[isError ? 'text-red-500' : 'text-gray-800']" data-cy="text_national_id_name">
            {{inputLbl.name}}
        </div>
        <div class="relative pb-5">
            <input type="tel"
                class="w-full bg-white px-3 py-1 placeholder-gray-500"
                :class="[isError ? 'border border-red-500' : 'border']"
                v-model="content"
                :placeholder="inputLbl.placeholder"
                :maxlength="inputMaxLength"
                @input="onChange()"
                data-cy="input_national_id_field">
            <div class="text-red-500 text-sm absolute bottom-0 left-0" v-if="isError" data-cy="text_national_id_error">
                {{getErrorMsg}}
            </div>
        </div>
    </div>
</template>
<script>
import Util from "@/helper/Utility.js";
import RegxHelper from "@/helper/RegxHelper.js";

/**
 * @property {String} v-model:inputValue (required) bind value
 * @property {Object} errorInfo (required) Validate result. example : { isValid: true, msg: '',}
 * @property {Boolean} isShowError (optional) Show/Hide Error label.
 * @property {Boolean} isSubmitted (optional) Show/Hide Error after save.
 * @property {Object} inputLbl (required) Text for component.
 */
export default {
    name: "InputNationalId",
    props: {
        // v-model
        inputValue:     { type: String },
        // props
        errorInfo:      { type: Object, required: true },
        isShowError:    { type: Boolean, default: false },
        isSubmitted:    { type: Boolean, default: false },
        // text
        inputLbl:       { type: Object, required: true },
    },
    data: function() {
        return {
            content: this.inputValue,
            inputMaxLength: 13,
            inputMinLength: 13,
        };
    },
    computed: {
        isError: function() {
            return (this.isShowError && this.isSubmitted && !this.errorInfo.isValid);
        },
        getErrorMsg: function() {
            return (this.isShowError && this.isSubmitted && !this.errorInfo.isValid) 
                ? this.errorInfo.msg
                : '';
        }
    },
    created: function() {
        if (this.maxLength > 0) {
            this.inputMaxLength = this.maxLength;
        }
    },
    mounted: function() {
        this.validateInput();
    },
    methods: {
        validateInput: function () {
            if (!this.inputLbl) {
                return;
            }
            // set default.
            this.errorInfo.setValid(true);
            this.errorInfo.setMsg('');
            // required
            if (this.inputLbl.required && !this.content) {
                this.errorInfo.setValid(false);
                this.errorInfo.setMsg(this.inputLbl.required)
                return;
            }
            // too short
            if (this.inputLbl.too_short && (this.content.length < this.inputMinLength)) {
                this.errorInfo.setValid(false);
                this.errorInfo.setMsg(Util.stringFormat(this.inputLbl.too_short, this.inputMinLength));
                return;
            }
            // invalid format
            if (this.inputLbl.invalid && this.content) {
                if (!Util.isNationalIdCard(this.content)) {
                    this.errorInfo.setValid(false);
                    this.errorInfo.setMsg(this.inputLbl.invalid);
                    return;
                }
            }
        },
        onChange: function() {
            var result = this.content;
            result = RegxHelper.removeNotNumber(result);

            this.content = result;
            this.validateInput();
            this.$emit('update:inputValue', result);
        },
    },
}
</script>
<style lang="scss" scoped>

</style>
